import React from 'react';
import { withStyles, Icon, BodyText } from 'vopay';
import { useTranslation } from 'react-i18next';
import styles from './Complete.module.scss';
import { Title, DetailsRows } from '../../UI';

const classes = withStyles(styles);

interface DetailRow {
  label: React.ReactNode;
  value: React.ReactNode;
}

interface CompleteProps {
  title: string;
  amount?: string;

  showAmounts?: boolean;
  details: DetailRow[];
  children?: React.ReactNode; // Optional additional content to render after details
  header?: React.ReactNode; // Optional header content to render above the title
  description?: React.ReactNode; // Optional description text to render below the title
  actionText?: React.ReactNode; // Custom text for the action (e.g., "You Sent", "You Received", etc.)
  recipientText?: React.ReactNode; // Custom full recipient text to override direction + username logic
  className?: string; // Optional custom className
}

const Complete: React.FC<CompleteProps> = ({
  title,
  amount,

  showAmounts = true,
  details,
  header,
  description,
  children,
  actionText,
  recipientText,
  className,
}) => {
  const { t } = useTranslation('translations', { keyPrefix: 'UI.Complete' });

  return (
    <div className={classes('container', className)}>
      {header && <div className={classes('header')}>{header}</div>}
      <div className={classes('content')}>
        {/* Success Icon */}
        <div className={classes('iconContainer')}>
          <div className={classes('successIcon')}>
            <Icon icon="check" height="34px" width="34px" color="primary-light" />
          </div>
          <Title level="3">{title}</Title>
          {description && <div className={classes('description')}>{description}</div>}
        </div>

        {/* Success Message */}
        {showAmounts && (
          <div className={classes('messageContainer')}>
            {actionText && <div className={classes('transactionType')}>{actionText}</div>}
            <Title level="1">{amount}</Title>
            <div className={classes('text')}>{recipientText}</div>
          </div>
        )}

        {/* Transaction Details */}
        <DetailsRows details={details} />

        {/* Additional Content */}
        {children}
      </div>
      {/* Footer */}
      <div className={classes('footer')}>
        <BodyText size="sm" weight="md" className={classes('poweredBy')}>
          {t('poweredBy')} <Icon icon="vLogoMark" height="20px" width="auto" color="primary-dark" />
        </BodyText>
      </div>
    </div>
  );
};

export default Complete;
